import cn from 'classnames';
import styles from './Skeleton.module.scss';

export const getClassNames = (animation: boolean, className?: string) => {
  return cn(styles.skeleton, { [styles['skeleton--animation']]: animation }, className);
};
